import { userWorkLogDeleted } from '../../../reducers/reports';
import { UserWorkLog } from '../../../types/apiDomain';
import { del } from '../../request';

const deleteUserWorkLog = (worklogId: string, user?: string) => async (dispatch) => {
    await del<UserWorkLog>({
        url: `/api/report/worklogs/${encodeURIComponent(worklogId)}`,
        params: { user }
    });

    return dispatch(userWorkLogDeleted({ worklogId }));
};

export default deleteUserWorkLog;
